/* -------------------------------------------
Format price according to the standards used at the website
1.234,89
--------------------------------------------- */
/* global frontendVars */
/* exported formatPrice */
const formatPrice = function (price, showEuroSign = false) {
  let displayPrice = price.toFixed(2).split(".");
  const firstNumbers = parseInt(displayPrice[0]).toLocaleString();
  let secondNumbers = displayPrice[1];
  const siteViewId = parseInt(frontendVars.siteviewId);

  //Format second numbers
  if (secondNumbers === "00") {
    secondNumbers = ",-";
  } else {
    secondNumbers =
      ',<sup class="price_small_digits">' + secondNumbers + "</sup>";
  }
  displayPrice = firstNumbers + secondNumbers; //Combine firstnumbers with seconnumbers
  if (showEuroSign) {
    //Display euro sign after for France
    if (siteViewId === 7) {
      displayPrice = `${displayPrice} &euro;`;
    } else {
      displayPrice = `&euro; ${displayPrice}`;
    }
  }
  return displayPrice;
};

export default formatPrice;
